import { soneMapStyle } from '../../maps/map-sone-style';
import { filterMarkers } from './filterMarkers';
import { getSensorData } from "./get-sensor-data";
import { capitalize } from "../../helpers/helpers";
import { sensorIcons } from "../../maps/sensor-icons";
import { showSensorChart } from "./show-sensor-chart";
const MarkerWithLabel = require('markerwithlabel')(google.maps);

/*
* Create Main Map.
*/
export const createMainMap = function (
    mapZoom,
    mapLat,
    mapLng,
    markersJson,
    markersStatesJson,
    mapTypeId
) {

    // Map Localization.
    let mapLatLng = {
        lat: mapLat,
        lng: mapLng
    };

    // Map Options.
    let mapOptions = {
        zoom: mapZoom,
        center: mapLatLng,
        mapTypeId: mapTypeId,
        streetViewControl: false,
        zoomControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        styles: soneMapStyle
    };

    // Init main map.
    let map = new google.maps.Map(
        document.getElementById('map--building'), mapOptions);

    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
            const userLatLng = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };

            new google.maps.Marker({
                position: userLatLng,
                map: map,
                title: "",
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 10,
                    fillColor: '#4285F4',
                    fillOpacity: 1,
                    strokeColor: '#ffffff',
                    strokeWeight: 2
                }
            });


        }, () => {
            console.error('Error: The Geolocation service failed.');
        });
    } else {
        console.error('Error: Your browser doesn\'t support geolocation.');
    }

    // Init markers.
    let markers = [];
    const notSelectedPinOpacity = 0.55;
    let selectedControlPointId = document.getElementById('selectedControlPointId').value;
    let curMarkerId;

    const findCurrentControlPointIndex = () => {
        return markersJson.findIndex(cp => cp.id == selectedControlPointId);
    };

    const updateMarkerOpacity = () => {
        markers.forEach(marker => {
            marker.setOptions({
                opacity: marker.sensorId == selectedControlPointId ? 1 : notSelectedPinOpacity
            });
        });
    };

    document.getElementById('cpNextBtn').addEventListener('click', () => {
        let currentIndex = findCurrentControlPointIndex();
        if (currentIndex < markersJson.length - 1) {
            let nextControlPoint = markersJson[currentIndex + 1];
            selectedControlPointId = nextControlPoint.id; // Update selectedControlPointId
            getSensorData(nextControlPoint.id, 'WEEK', 'c-box-building-stats__chart--1', 'LineChart', nextControlPoint.label);
            updateMarkerOpacity(); // Update marker opacity
        }
    });

    document.getElementById('cpPrevBtn').addEventListener('click', () => {
        let currentIndex = findCurrentControlPointIndex();
        if (currentIndex > 0) {
            let prevControlPoint = markersJson[currentIndex - 1];
            selectedControlPointId = prevControlPoint.id; // Update selectedControlPointId
            getSensorData(prevControlPoint.id, 'WEEK', 'c-box-building-stats__chart--1', 'LineChart', prevControlPoint.label);
            updateMarkerOpacity(); // Update marker opacity
        }
    });

    for (let i = 0; i < markersJson.length; i++) {
        if (markersJson[i].geoCoordinates) {
            let lat = markersJson[i].geoCoordinates.lat;
            let lng = markersJson[i].geoCoordinates.lng;
            let latLng = new google.maps.LatLng(lat, lng);
            let sensorId = markersJson[i].id;
            let deviceType = markersJson[i].deviceType.name.toLowerCase();

            // Get sensor type.
            let sensorType = markersJson[i].deviceType.name.toLowerCase();

            // Get sensor status.
            let sensorStatus = markersJson[i].status;
            sensorStatus = (sensorStatus) ? capitalize(sensorStatus.name.toLowerCase()) : capitalize('grey');

            // Set sensor icon.
            let sensorIcon = `${sensorType}${sensorStatus}`;

            // Set opacity to first control point. WARNING: comparing int with string thus using == instead of ===
            let sensorOpacity = (sensorId == selectedControlPointId) ? 1 : notSelectedPinOpacity;

            let markerLabel = markersJson[i].label;

            let marker = new MarkerWithLabel({
                position: latLng,
                icon: sensorIcons[sensorIcon],
                map: map,
                sensorId: sensorId,
                sensorType: deviceType,
                opacity: sensorOpacity,
                labelContent: markerLabel,
                labelClass: `c-marker-label c-marker-label--${sensorStatus.toLowerCase()}`,
                labelStyle: {
                    zIndex: 10,
                    opacity: 0,
                },
                zIndex: 10,
            });
            markers.push(marker);

            // Show sidebar with chart after click on marker.
            marker.addListener('click', function () {
                curMarkerId = this.sensorId;

                for (const marker of markers) {
                    marker.setOptions({
                        opacity: notSelectedPinOpacity
                    });
                }

                marker.setOptions({
                    opacity: 1
                });

                showSensorChart(curMarkerId, markerLabel);
                selectedControlPointId = curMarkerId;
            });

            google.maps.event.addListener(marker, 'mouseover', function () {
                this.setOptions({
                    zIndex: 999999,
                    labelClass: marker.labelClass.replace(' c-marker-label--transparent', ''),
                    labelStyle: {
                        zIndex: 100,
                    },
                });
            });

            google.maps.event.addListener(marker, 'mouseout', function () {
                this.setOptions({
                    zIndex: 10,
                    labelStyle: {
                        zIndex: 10,
                        opacity: 0,
                    },
                });
            });
        }
    }

    const getUrlParameter = (name) => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    };

    const filterMarkersByUrl = (markers) => {
        const selectedSensorType = getUrlParameter('selectedSensorType') || 'dsw';
        filterMarkers(selectedSensorType, markers);
    };

    filterMarkersByUrl(markers);
};
